import { render, staticRenderFns } from "./SkillOfSpeaking.vue?vue&type=template&id=fcc30b80&scoped=true"
import script from "./SkillOfSpeaking.vue?vue&type=script&lang=js"
export * from "./SkillOfSpeaking.vue?vue&type=script&lang=js"
import style0 from "./SkillOfSpeaking.vue?vue&type=style&index=0&id=fcc30b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc30b80",
  null
  
)

export default component.exports